<template>
    <div>
        <v-toolbar color="white">
            <v-toolbar-title> </v-toolbar-title>

            <div class="flex-grow-1"></div>

            <div>
                <v-btn variant="text" to="/login">{{ $t('login') }}</v-btn>
                <span class="pa-1"></span>
            </div>

            <v-toolbar-items>

            </v-toolbar-items>

            <template v-if="smAndUp">
                <v-col sm="1">
                    <v-select class="mt-6" :items="locales" v-model="currentLocale" @update:model-value="changeLocale" rounded
                              item-title="text" item-value="value">
                    </v-select>
                </v-col>
            </template>

        </v-toolbar>
        <v-main>
            <section>
                <v-parallax :src="heroImg" height="600">
                    <v-row class="text-white" align="center" justify="center" style="height: 100%">
                        <v-col cols="12" class="text-center">
                            <img :src="dbbLogo" alt="Book Stay BNB" style="height: 200px; margin-bottom: 20px;">
                            <h1 class="text-blue mb-2 text-center" style="color: #1976d2; font-size: 3em; font-weight: bold;">Book Stay BNB</h1>
                            <div class="text-subtitle-1 mb-4 text-center">Direct Booking Platform for Short-Term Rentals</div>
                        </v-col>
                    </v-row>
                </v-parallax>
            </section>

            <section>
                <v-row
                        class="my-12"
                        align="center"
                        justify="center"
                >
                    <v-col cols="12" sm="8" class="my-4">
                        <div class="text-center">
                            <h2 class="text-h4" style="color: #1976d2; font-weight: bold;">Why Book Stay BNB?</h2>
                            <span class="text-subtitle-1">
                Take control of your direct bookings and maximize your revenue
              </span>
                        </div>
                    </v-col>
                    <v-col cols="12">
                        <v-container>
                            <v-row align="center">
                                <v-col cols="12" md="6">
                                    <v-card flat color="transparent">
                                        <v-card-text class="text-center">
                                            <v-icon size="x-large" color="blue-lighten-2">mdi-link</v-icon>
                                        </v-card-text>
                                        <v-card-title class="justify-center">
                                            <div class="text-h5 text-center">Hospitable Integration</div>
                                        </v-card-title>
                                        <v-card-text>
                                            Seamlessly integrate with Hospitable.com to manage your property reservations.
                                            Sync your availability and bookings in real-time across all your channels.
                                        </v-card-text>
                                    </v-card>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-card flat color="transparent">
                                        <v-card-text class="text-center">
                                            <v-icon size="x-large" color="blue-lighten-2">mdi-payment</v-icon>
                                        </v-card-text>
                                        <v-card-title class="justify-center">
                                            <div class="text-h5">PayPal Payments</div>
                                        </v-card-title>
                                        <v-card-text>
                                            Secure payment processing through PayPal integration. Accept payments from guests
                                            worldwide with confidence and ease.
                                        </v-card-text>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-col>
                </v-row>
            </section>

            <section>
                <v-parallax :src="sectionImg" height="380">
                    <v-row align="center" justify="center" style="height: 100%">
                        <v-col cols="12" class="text-center">
                            <div class="text-h5 text-white mb-4 text-center"> Empower Your Property with Book Stay BNB
                            </div>
                        </v-col>
                    </v-row>
                </v-parallax>
            </section>

            <section>
                <v-container>
                    <v-row justify="center" class="my-12">
                        <v-col cols="12" md="8">
                            <v-card>
                                <v-card-title class="justify-center" style="color: #1976d2; font-weight: bold;">
                                    <div class="text-h4">Interested in Direct Booking for Your Property?</div>
                                </v-card-title>
                                <v-card-text class="pa-8">
                                    <p class="mb-6 text-body1">Get more information about how Book Stay BNB can help you manage bookings and payments for your short-term rental. Fill out the form below and our team will contact you soon.</p>
                                    
                                    <v-form @submit.prevent="submitForm">
                                        <v-text-field
                                            v-model="form.name"
                                            label="Full Name"
                                            outlined
                                            required
                                            class="mb-4"
                                        ></v-text-field>

                                        <v-text-field
                                            v-model="form.email"
                                            label="Email Address"
                                            type="email"
                                            outlined
                                            required
                                            class="mb-4"
                                        ></v-text-field>

                                        <v-text-field
                                            v-model="form.phone"
                                            label="Phone Number (Optional)"
                                            outlined
                                            class="mb-4"
                                        ></v-text-field>

                                        <v-text-field
                                            v-model="form.propertyName"
                                            label="Property Name/Location"
                                            outlined
                                            required
                                            class="mb-4"
                                        ></v-text-field>

                                        <v-textarea
                                            v-model="form.message"
                                            label="Tell us about your property and your booking needs"
                                            outlined
                                            rows="4"
                                            class="mb-4"
                                        ></v-textarea>

                                        <v-checkbox
                                            v-model="form.newsletter"
                                            label="Subscribe to our newsletter for updates and tips"
                                            class="mb-4"
                                        ></v-checkbox>

                                        <v-btn
                                            type="submit"
                                            color="blue-lighten-2"
                                            dark
                                            size="large"
                                            block
                                        >
                                            Send Inquiry
                                        </v-btn>
                                    </v-form>

                                    <v-alert
                                        v-if="formStatus.show"
                                        :type="formStatus.type"
                                        class="mt-4"
                                    >
                                        {{ formStatus.message }}
                                    </v-alert>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
            </section>

            <v-footer color="blue-darken-2">
                <v-row align="center">
                    <v-col cols="12">
                        <div class="text-white ml-4">
                            <span>&copy; {{ new Date().getFullYear() }}</span>
                        </div>
                    </v-col>
                </v-row>
            </v-footer>

        </v-main>
    </div>
</template>


<script>
    import { useDisplay } from 'vuetify'
    import heroImg from './assets/hero.jpeg'
    import sectionImg from './assets/section.jpg'
    import dbbLogo from './dbb-logo.png'

    export default {
        setup() {
            const { smAndUp } = useDisplay();
            return { smAndUp };
        },
        data() {
            return {
                heroImg,
                sectionImg,
                dbbLogo,
                currentLocale: localStorage.getItem('locale') || navigator.language.split('-')[0],
                locales: [
                    { flag: 'us', value: 'en', text: 'English' },
                    { flag: 'ru', value: 'ru', text: 'Русский' }
                ],
                form: {
                    name: '',
                    email: '',
                    phone: '',
                    propertyName: '',
                    message: '',
                    newsletter: false
                },
                formStatus: {
                    show: false,
                    type: 'success',
                    message: ''
                }
            };
        },
        methods: {
            changeLocale(code) {
                this.$i18n.locale = code;
                localStorage.setItem('locale', code);
            },
            async submitForm() {
                // Validate required fields
                if (!this.form.name || !this.form.email || !this.form.propertyName) {
                    this.formStatus = {
                        show: true,
                        type: 'error',
                        message: 'Please fill in all required fields.'
                    };
                    return;
                }

                try {
                    // Send inquiry to backend API
                    const response = await fetch('/api/inquiries', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            name: this.form.name,
                            email: this.form.email,
                            phone: this.form.phone,
                            propertyName: this.form.propertyName,
                            message: this.form.message,
                            newsletter: this.form.newsletter
                        })
                    });

                    const data = await response.json();

                    if (response.ok) {
                        this.formStatus = {
                            show: true,
                            type: 'success',
                            message: data.message || 'Thank you for your inquiry! Our team will contact you soon.'
                        };
                        // Reset form
                        this.form = {
                            name: '',
                            email: '',
                            phone: '',
                            propertyName: '',
                            message: '',
                            newsletter: false
                        };
                    } else {
                        this.formStatus = {
                            show: true,
                            type: 'error',
                            message: data.message || 'Failed to submit inquiry. Please try again.'
                        };
                    }

                    // Hide message after 5 seconds
                    setTimeout(() => {
                        this.formStatus.show = false;
                    }, 5000);

                } catch (error) {
                    console.error('Error submitting inquiry:', error);
                    this.formStatus = {
                        show: true,
                        type: 'error',
                        message: 'An error occurred. Please try again later.'
                    };
                    // Hide message after 5 seconds
                    setTimeout(() => {
                        this.formStatus.show = false;
                    }, 5000);
                }
            }
        }
    }
</script>

<style scoped>

</style>
